/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const shouldUseSmallerGrid = (layoutContext) => {
    const { isMobileApp, windowSize } = layoutContext;
    const isSmallWindow = windowSize === 'xs' || windowSize === 'sm';
    return isSmallWindow || isMobileApp;
};
